import React, { useEffect, useState } from "react";
import axios from "axios";
import InputMask from "react-input-mask";
import MaterialInput from "@material-ui/core/Input";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Button, Label, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import UrlUtils from "../../services/utils/UrlUtils";
import UserUtils from "../../services/utils/UserUtils";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
import {
    API_URL_VERIFY_OTP,
    API_URL_RESEND_OTP,
    API_URL_AZURE_LOGIN,
    API_URL_SIGN_IN
} from "../../common/constants";
import { LOCAL_STORAGE_KEY_ACCESS_TOKEN } from "../../services/constants/LocalStorage";
import {
    checkLogin,
    setUserAccessToken,
    changeWorkspace,
    errorNotification,
    successNotification,
    loginErrorFlag,
    loginUserSuccessful,
    appLoadStatusChanged,
    saveOrganizationActiveModuleOnRemote,
    setOrganizationActiveModule
} from "../../store/actions";

import Password from "../../components/Fields/Password";
import OrganizationHeader from "./components/OrganizationHeader";
import ConsentModal from "./ConsentModal";

const Login = (props) => {
    const {
        loginUserSuccessful,
        appLoadStatusChanged,
        saveOrgModuleOnRemote,
        changeActiveModule,
        changeWorkspace,
        errorNotification,
        setUserAccessToken,
        history,
        organizationModules,
        t,

        user: currentUser,
        organization
    } = props; 

    const urlUtils = new UrlUtils();
    const userUtils = new UserUtils();

    const searchQueries = new URLSearchParams(window.location.search);
    const [otp, setOtp] = useState({
        error: false,
        message: "",
        code: null
    });
    const [countDown, setCountDown] = useState(60);
    const [isThirdPartyUrl, setIsThirdPartyUrl] = useState(false);

    const [ consentData, setConsentData ] = useState(null);

    const [userAuthenticationIsInProcess, setUserAuthenticationIsInProcess] = useState(false);
    const [otpVerificationIsInProcess, setOtpVerificationIsInProcess] = useState(false);

    const clearCache = () => {
        if ("caches" in window) {
            caches.keys().then(function (cacheNames) {
                cacheNames.forEach(function (cacheName) {
                    caches.delete(cacheName);
                });
            });
        }
    }

    const clearCoockies = () => {
        document.cookie.split(";").forEach(function (cookie) {
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        });
    }

    const setWorkspace = () => {
        changeWorkspace(userUtils.getWorkspace(currentUser));
    }

    const getAfterLoginRedirectRoute = () => {
        let redirectUrl = searchQueries.get(
            "redirectUrl"
        );

        if (redirectUrl) {
            let resultModule = null;
            const splitedRedirectUrl = redirectUrl.split("--");

            if (splitedRedirectUrl.length > 1) {
                const selectedModule = (new URLSearchParams(splitedRedirectUrl[1])).get(
                    "module"
                );

                if (selectedModule && (currentUser.activeModules || []).find((m) => {
                    return m.domain === selectedModule;
                })){
                    resultModule = selectedModule;
                }
            }

            redirectUrl = splitedRedirectUrl[0];

            if (redirectUrl.split("/").filter((i) => i).length === 2) {
                if (redirectUrl[redirectUrl.length - 1] === "/") {
                    redirectUrl = `${redirectUrl}admin`;
                } else {
                    redirectUrl = `${redirectUrl}/admin`;
                }
            }

            let inAppRoute = redirectUrl.replace(/^\/+|\/+$/g, '').split('/');
            inAppRoute.splice(0, 2) /// delete organization infos

            if((inAppRoute[0] === 'third-party' && userUtils.isThirdParty(currentUser)) || (
                inAppRoute[0] === 'employee' && userUtils.isEmployee(currentUser)
            ) || (
                inAppRoute[0] === 'admin' && userUtils.isAnalystOrAnalystAdmin(currentUser)
            )) {
                return {
                    url: `/${inAppRoute.join('/')}`,
                    moduleInUrl: resultModule
                };
            }
        }

        return {};
    }

    const handleAfterLogin = () => {
        setUserAccessToken(currentUser.tempToken || currentUser.token);
        localStorage.setItem(
            LOCAL_STORAGE_KEY_ACCESS_TOKEN,
            currentUser.tempToken || currentUser.token
        );
        setWorkspace();
        
        const {
            moduleInUrl,
            url: redirectUrl
        } = getAfterLoginRedirectRoute();

        const userCurrentModuleInServer = currentUser.module?.domain;
        const userCurrentModuleInLocal = organizationModules.active;

        if(redirectUrl && moduleInUrl) {
            saveOrgModuleOnRemote(moduleInUrl)

            setTimeout(() => {
                history.push(redirectUrl);
            }, 500);
        }
        else {
            if (organization.isTPDDSupplier) {
                return history.push(
                    userUtils.getUserHomeRoute(currentUser, 'tp')
                )
            }

            if(userCurrentModuleInLocal === userCurrentModuleInServer) {
                return history.push(
                    userUtils.getUserHomeRoute(currentUser, userCurrentModuleInLocal)
                )
            }

            return history.push(
                userUtils.getUserStartPageRoute(currentUser)
            );
        }
    }

    const loginUser = (user) => {
        setUserAuthenticationIsInProcess(true);

        axios.post(API_URL_SIGN_IN, {
            "2fa": true,
            username: user.username,
            password: user.password,
            organization: user.organization,
            isThirdPartyUser: user.isThirdPartyUser,
        }).then((res) => {
            if (res.data && res.data.ok) {
                const { data } = res.data;

                loginUserSuccessful({
                    ...data.profile,
                    needExchange: !!data.needExchange,
                    tempToken: data.token,
                    module: data.currentModule,
                    activeModules: data.activeModules
                });
                appLoadStatusChanged(true);
            } 
            else {
                const { error, message } = res.response.data;
                errorNotification({
                    code: error,
                    message: t(message),
                });
            }
        }).catch((err) => {
            if (err && err.response && err.response.data) {
                const { error, message } = err.response.data;

                if (error && message) {
                    errorNotification({
                        code: error,
                        message: t(message),
                    });
                }
            }
        }).finally(() => {
            setUserAuthenticationIsInProcess(false)
        });
    };

    const handleSubmit = (event, values) => {
        if(userAuthenticationIsInProcess) return;

        values.organization = urlUtils.getOrganizationId();
        if (urlUtils.getUrlParamThirdParty() === "third-party") {
            values.signin = urlUtils.getUrlParamThirdParty();
            values.isThirdPartyUser = true;
        } 
        else {
            values.signin = "others";
            values.isThirdPartyUser = false;
        }

        localStorage.setItem("org", urlUtils.getOrganizationName());

        loginUser(values);
    }

    const checkUrlParamThirdParty = () => {
        const result = urlUtils.getUrlParamThirdParty() === "third-party";
        setIsThirdPartyUrl(result);
    }

    const verifyOTPCode = () => {
        const otpCode = otp.code.replaceAll("-", "");
        if (otpCode === "") {
            return errorNotification({
                code: "invalid_otp",
                message: t("Invalid OTP")
            });
        }

        setOtpVerificationIsInProcess(true);
    
        axios.post(
            API_URL_VERIFY_OTP,
            { 
                otp: otpCode 
            },
            {
                headers: {
                    Authorization: `Bearer ${currentUser.tempToken}`,
                }
            }
        ).then(async (response) => {
            const data = response.data;
            if (data.ok === false) {
                return errorNotification({
                    code: "invalid_otp",
                    message: t("Invalid OTP")
                });
            }

            handleAfterLogin();
        }).catch((err) => {
            errorNotification({
                code: "invalid_otp",
                message: t("Invalid OTP")
            });
        }).finally(() => {
            setOtpVerificationIsInProcess(false);
        });
    }

    const startCountDown = () => {
        const interval = setInterval(() => {
            setCountDown((prevCountDown) => {
                const newCountDown = prevCountDown - 1;
                if(newCountDown < 1) {
                    clearInterval(interval);
                }
                return newCountDown;
            })
        }, 1000);
    };

    const resendOTP = () => {
        const data = {
            token: currentUser && currentUser.tempToken,
        };

        const header = {
            headers: {
                Authorization: `Bearer ${currentUser.tempToken}`,
            }
        };
    
        axios.post(API_URL_RESEND_OTP, data, header)
        .then((response) => {
            const data = response.data;
    
            if (data.ok === false) {
                errorNotification({
                    code: "invalid_token",
                    message: t(data.error[0])
                });
            } 
            else {
                setCountDown(60);
                setTimeout(() => {
                    startCountDown();
                }, 250);
            }
        }).catch((error) => {
            if (error.response) {
                const data = error.response.data;
                errorNotification({
                    code: data.error || "unknown_error",
                    message: t(data.message || data.title)
                });
            } 
            else {
                errorNotification({
                    code: "invalid_token",
                    message: t(error.error[0])
                });
            }
        });
    }

    const onOTPChange = (e) => {
        setOtp((currentState) => ({...currentState, code: e.target.value}));
    }

    const onClickAzureLogin = (e) => {
        axios.post(API_URL_AZURE_LOGIN, { 
            organizationId: urlUtils.getOrganizationId(),
        }, 
        { 
            withCredentials: true 
        }).then((res) => {
            window.location.replace(res.data.data);
        });
    };

    useEffect(() => {
        if(!userAuthenticationIsInProcess){
            clearCoockies();
            clearCache();
        }
    }, [ userAuthenticationIsInProcess ]);

    useEffect(() => {
        document.body.classList.add("auth-body-bg");
        checkUrlParamThirdParty();

        if (currentUser && currentUser.tempToken) {
            setUserAccessToken(currentUser.tempToken);
            localStorage.setItem(
                LOCAL_STORAGE_KEY_ACCESS_TOKEN,
                currentUser.tempToken
            );
            setWorkspace();
            history.push(userUtils.getUserHomeRoute(currentUser));
        }

        return () => document.body.classList.remove("auth-body-bg");
    }, []);

    useEffect(() => {
        if(currentUser){
            if(currentUser.needExchange){
                startCountDown();
            }
            else{
                if(currentUser.tempToken){
                    if(!currentUser.consentStatus){
                        setConsentData({
                            token: currentUser.tempToken
                        });
                    }
                    else{
                        handleAfterLogin();
                    }
                }
            }
        }
    }, [ currentUser ]);

    const renderOTPForm = () => {
        return (
            <div>
                <div className="p-2 mt-5">
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={verifyOTPCode}
                    >
                        <div className="mb-3">
                            <Label className="form-label">
                                {t("Enter code")}
                            </Label>
                            <InputMask
                                autoFocus
                                mask="9-9-9-9-9-9"
                                className="form-control input-color"
                                value={otp.code}
                                onChange={(e) => onOTPChange(e)}
                            >
                                {(inputProps) => (
                                    <MaterialInput {...inputProps} disableUnderline />
                                )}
                            </InputMask>
                        </div>

                        <div className="mt-4 text-center">
                            <Button
                                color="primary"
                                disabled={otpVerificationIsInProcess}
                                className="w-md waves-effect waves-light"
                                type="submit"
                            >
                                {otpVerificationIsInProcess && (
                                    <Spinner 
                                        size="sm" 
                                        color="white"
                                        className="me-2" 
                                    />
                                )}
                                {t("Submit")}
                            </Button>
                        </div>
                        <div className="mt-4 text-center">
                            <Button
                                color="link"
                                className="w-md waves-effect waves-light"
                                type="button"
                                disabled={countDown > 0}
                                onClick={resendOTP}
                            >
                                {countDown < 1 ? t("Resend") : `${t("Resend OTP in")} ${countDown}`}
                            </Button>
                        </div>
                    </AvForm>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Row className="g-0">
                <Col lg={4}>
                    <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                        <div className="w-100">
                            <Row className="justify-content-center">
                                <Col lg={9}>
                                    <div>
                                        <OrganizationHeader />
                                        {currentUser && currentUser.needExchange ? (
                                            renderOTPForm()
                                        ) : (
                                            <div>
                                                <div className="p-2 mt-5">
                                                    <AvForm
                                                        className="form-horizontal"
                                                        onValidSubmit={handleSubmit}
                                                    >
                                                    <div className="auth-form-group-custom mb-4">
                                                        <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                        <Label htmlFor="username">
                                                            {isThirdPartyUrl ? t("Username/Email") : t("Email")}
                                                        </Label>
                                                        <AvField
                                                            name="username"
                                                            type="text"
                                                            className="form-control bootstrap-default"
                                                            id="username"
                                                            onChange={() => {
                                                                return loginErrorFlag(false);
                                                            }}
                                                            errorMessage={t(
                                                                "This field cannot be blank"
                                                            )}
                                                            validate={{
                                                                required: true,
                                                            }}
                                                            placeholder=""
                                                            defaultValue={searchQueries.get('username') || ''}
                                                        />
                                                    </div>

                                                    <div className="auth-form-group-custom mb-4">
                                                        <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                        <Label htmlFor="userpassword">
                                                            {t("Password")}
                                                        </Label>
                                                        <Password
                                                            name="password"
                                                            id="userpassword"
                                                            placeholder=""
                                                            errorMessage={t(
                                                                "This field cannot be blank"
                                                            )}
                                                            onChange={() => {
                                                                return loginErrorFlag(false);
                                                            }}
                                                            validate={{
                                                                required: true,
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="mt-4 text-center">
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            disabled={ userAuthenticationIsInProcess }
                                                            tabIndex={0}
                                                        >
                                                            {userAuthenticationIsInProcess && (
                                                                <Spinner
                                                                    size="sm"
                                                                    color="white"
                                                                    className="me-2"
                                                                />
                                                            )}
                                                            {t("Log In")}
                                                        </Button>

                                                    </div>
                                                    {isThirdPartyUrl && !organization.isTPDDSupplier ? (
                                                        <div className="mt-4 text-center">
                                                            <Link
                                                                to="/third-party/register"
                                                                className="text-muted"
                                                            >
                                                                <span>
                                                                    {`${t("Need an account")}?`}
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textDecoration: "underline",
                                                                        paddingLeft: 6,
                                                                    }}
                                                                >
                                                                    {t("Register now")}!
                                                                </span>
                                                            </Link>
                                                        </div>
                                                    ) : (
                                                        <div className="mt-4 text-center">
                                                        <Link
                                                            to="/reset-password"
                                                            className="text-muted"
                                                        >
                                                            <i className="mdi mdi-lock me-1"></i>
                                                            {t("I forgot my password")}
                                                        </Link>
                                                        </div>
                                                    )}
                                                    </AvForm>
                                                </div>

                                                {isFeatureEnabledForActiveModule(
                                                    "ad-settings"
                                                ) &&
                                                    !isThirdPartyUrl && organization && organization.azureLogin ? (
                                                    <div className="d-block p-2">
                                                        <Button
                                                            className="w-md waves-effect waves-light"
                                                            type="button"
                                                            onClick={onClickAzureLogin}
                                                            style={{
                                                                width: "100%",
                                                                height: 57,
                                                                textAlign: "center",
                                                                backgroundColor: "#fff",
                                                                border: "1px solid #ced4da",
                                                                marginTop: 9,
                                                            }}
                                                        >
                                                            <div
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                    left: 6,
                                                                    position: "absolute",
                                                                    }}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                                                                        <rect
                                                                            x="1"
                                                                            y="1"
                                                                            width="9"
                                                                            height="9"
                                                                            fill="#f25022"
                                                                        />
                                                                        <rect
                                                                            x="1"
                                                                            y="11"
                                                                            width="9"
                                                                            height="9"
                                                                            fill="#00a4ef"
                                                                        />
                                                                        <rect
                                                                            x="11"
                                                                            y="1"
                                                                            width="9"
                                                                            height="9"
                                                                            fill="#7fba00"
                                                                        />
                                                                        <rect
                                                                            x="11"
                                                                            y="11"
                                                                            width="9"
                                                                            height="9"
                                                                            fill="#ffb900"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <span
                                                                    style={{
                                                                        color: "#666",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    {t("Continue with Microsoft")}
                                                                </span>
                                                            </div>
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="mt-5 text-center">
                                                    <p>
                                                        {t('Need assistance?')} <a href='https://diss-co.atlassian.net/servicedesk/customer/portal/36/user/login' target="_blank" rel="noreferrer">
                                                            {t('Contact Support')}
                                                        </a>
                                                    </p>
                                                    <p>
                                                    {`© 2026 SMART INTEGRITY PLATFORM. ${t('All rights reserved.')}`}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>

                <Col lg={8}>
                    <div className="authentication-bg">
                    <div className="bg-overlay"></div>
                    </div>
                </Col>
            </Row>
            
            <ConsentModal
                modalData={consentData}
                toggleModal={() => setConsentData(null)}
                consentAccepted={handleAfterLogin}
            />
        </div>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.Login.user,
        token: state.Login.token,
        organization: state.Organization,
        organizationModules: state.Modules
    };
};

export default withNamespaces()(
  withRouter(
    connect(mapStatetoProps, {
        checkLogin,
        setUserAccessToken,
        loginErrorFlag,
        changeWorkspace,
        errorNotification,
        successNotification,
        loginUserSuccessful,
        appLoadStatusChanged,
        saveOrgModuleOnRemote  : (module) => saveOrganizationActiveModuleOnRemote(module),
        changeActiveModule : (module) => setOrganizationActiveModule(module)
    })(Login)
  )
);
